import React from "react";
import {
  StyledAbout,
  Left,
  PhotoBox,
  PhotoRow,
  Photo,
  Right,
  TextBox,
  BoldText,
  MobileIconText,
  MobileText,
  SubTextBox,
  SubText,
  ButtonBox,
  StandIn,
 
} from "./styles";

import { Button } from "../Button/Button.js";
import { SocialIcons } from "../SocialIcons/SocialIcons";

export const About = ({ aboutAni }) => (
  
  <StyledAbout>
    {/* // {aboutAni ? ( */}
      <React.Fragment>
      
        <Left id="swmc">
          <PhotoBox>
            <PhotoRow>
              <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-1.png" />
              <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-2.png" />
            </PhotoRow>
            <PhotoRow>
              <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-3.png" />
              <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-4.png" />
            </PhotoRow>
            <PhotoRow>
              <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-5.png" />
              <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-6.png" />
            </PhotoRow>
          </PhotoBox>
        </Left>

        <Right>
          <div className="d-lg-none d-md-none SocialMediaMobileIcon justify-content-center ">
        <MobileIconText className="pt-4 text-align-center">Social Media</MobileIconText>
        <MobileText>Click on Our Links</MobileText>
          <div className="d-lg-none d-flex justify-content-center ">
          <SocialIcons />
          </div>
          </div>
          <TextBox>
            <BoldText>About Us</BoldText>
            <SubTextBox>
              <SubText>
                Sun West Mortgage is proud to be a household name within the
                Mortgage industry. An industry leader with a focus towards
                client satisfaction and streamlined technology we deliver low
                rates, cost savings and great service. We are one of the largest
                privately owned mortgage-backed originators and servicers. If
                the loan makes sense, we close it.
              </SubText>

              <SubText>
                Sun West Mortgage is a HUD approved mortgagee (FHA and HECM), VA
                LAPP approved, USDA, Fannie Mae and Freddie Mac approved
                Seller/Servicer and Ginnie Mae Issuer. We are also a leader in
                HMBS securitization and residential and commercial MBS.
              </SubText>
            </SubTextBox>
            <ButtonBox>
              {/* YTH-23 updating link redirection to AutismHeroes landing page */}
              <Button link="https://www.swmc.com/autismheroes" text="Visit Our Website" />
            </ButtonBox>
          </TextBox>
        </Right>
      </React.Fragment>
     {/* ) : (
    //   <StandIn>
    //     <Left id="swmc">
    //       <PhotoBox>
    //         <PhotoRow>
    //           <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-1.png" />
    //           <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-2.png" />
    //         </PhotoRow>
    //         <PhotoRow>
    //           <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-3.png" />
    //           <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-4.png" />
    //         </PhotoRow>
    //         <PhotoRow>
    //           <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-5.png" />
    //           <Photo src="https://resources.swmc.com/images/yourtruehome/panel-people-6.png" />
    //         </PhotoRow>
    //       </PhotoBox>
    //     </Left>

    //     <Right>
    //       <TextBox>
    //         <BoldText>About Us</BoldText>
    //         <SubTextBox>
    //           <SubText>
    //             Sun West Mortgage is proud to be a household name within the
    //             Mortgage industry. An industry leader with a focus towards
    //             client satisfaction and streamlined technology we deliver low
    //             rates, cost savings and great service. We are one the largest
    //             privately owned mortgage-backed originators and servicers. If
    //             the loan makes sense, we close it.
    //           </SubText>

    //           <SubText>
    //             Sun West Mortgage is a HUD approved mortgagee (FHA & HECM), VA
    //             LAPP approved, USDA, Fannie Mae and Freddie Mac approved
    //             Seller/Servicer and Ginnie Mae Issuer. We are also a leader in
    //             HMBS securitization and residential and commercial MBS.
    //           </SubText>
    //         </SubTextBox>
    //         <ButtonBox>
    //           {/* YTH-23 updating link redirection to AutismHeroes landing page 
    //           <Button link="https://www.swmc.com/autismheroes" text="Visit Our Website" />
    //         </ButtonBox>
    //       </TextBox>
    //     </Right>
    //   </StandIn>
     )} */}
  </StyledAbout>
);
